var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPadUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#E7E7E7",
    stroke: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2039,
    y: 39.8135,
    width: 25.2654,
    height: 6.11533,
    transform: "rotate(-135.547 42.2039 39.8135)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7078,
    y: 39.4399,
    width: 6.75984,
    height: 18.5232,
    transform: "rotate(-134.791 16.7078 39.4399)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.42 18.1799L47 34.7599L41.34 40.4199L29 28.0799L16.66 40.4199L11 34.7799L27.58 18.1799C27.7659 17.9925 27.9871 17.8437 28.2308 17.7421C28.4746 17.6406 28.736 17.5883 29 17.5883C29.264 17.5883 29.5254 17.6406 29.7692 17.7421C30.0129 17.8437 30.2341 17.9925 30.42 18.1799Z",
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPadUp);
export default __webpack_public_path__ + "static/media/button-pad-up.a52fff0f2c6d699621588a58a4b3cb8c.svg";
export { ForwardRef as ReactComponent };